import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { RewardsHubDashboardDto } from '@model/RewardsHubDashboardDto'

export const useRewardsHubDashboard = (
  options: { enabled?: boolean } = {}
): {
  rewardsHubDashboard: RewardsHubDashboardDto | undefined
  isLoading: boolean
} => {
  const apiClient = useApiClient(ClientApiClient)
  const { enabled = true } = options

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.rewardsHub.dashboard(),
    queryFn: () => apiClient.getRewardsHubDashboard(),
    enabled,
  })

  return { rewardsHubDashboard: data, isLoading }
}
